import axios from '@util/axios'
import store from '@store'

const withUserEmail = (data) => ({
  ...data,
  user_email: (store.getters.user && store.getters.user.email) || ''
})

const buildQuery = (params) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&')

export const InvoiceChargeService = {
  list: (bdxKey, params = {}, options = {}) =>
    axios({
      ...options,
      skipToast: true,
      url: `lincoln/billing/invoice-charge/?${buildQuery({ bdx_key: bdxKey, ...params })}`,
    }),

  create: (data, options = {}) =>
    axios({
      ...options,
      skipToast: true,
      url: `lincoln/billing/invoice-charge/`,
      method: 'POST',
      data: withUserEmail(data)
    }),

  update: (id, data, options = {}) =>
    axios({
      ...options,
      skipToast: true,
      url: `lincoln/billing/invoice-charge/${id}/`,
      method: 'PUT',
      data
    }),

  destroy: (id, data = {}, options = {}) =>
    axios({
      ...options,
      skipToast: true,
      url: `lincoln/billing/invoice-charge/${id}/`,
      method: 'DELETE',
      data: withUserEmail(data)
    }),

  credit: (id, data, options = {}) =>
    axios({
      ...options,
      skipToast: true,
      url: `lincoln/billing/invoice-charge/${id}/credit/`,
      method: 'POST',
      data: withUserEmail(data)
    }),

  availablePeriods: (bdxKey, options = {}) =>
    axios({
      ...options,
      skipToast: true,
      url: `lincoln/billing/invoice-charge/available-periods/?${buildQuery({ bdx_key: bdxKey })}`,
    }),

  checkDuplicates: (bdxKeys, reportingPeriod, options = {}) =>
    axios({
      ...options,
      skipToast: true,
      url: `lincoln/billing/invoice-charge/check-duplicates/`,
      method: 'POST',
      data: { bdx_keys: bdxKeys, reporting_period: reportingPeriod }
    })
}
